import { formatBytes } from "../util";

export interface TransferStats {
  speedFormatted: string;
  etaFormatted: string;
  percent: number;
}

export class SpeedTracker {
  private startTime = 0;
  private lastSampleTime = 0;
  private lastSampleBytes = 0;
  private smoothedSpeed = 0;

  start() {
    this.startTime = Date.now();
    this.lastSampleTime = this.startTime;
    this.lastSampleBytes = 0;
    this.smoothedSpeed = 0;
  }

  update(bytesDone: number, bytesTotal: number): TransferStats {
    const now = Date.now();
    const elapsedTotal = Math.max(0.1, (now - this.startTime) / 1000);

    if (this.lastSampleTime === 0) {
      this.start();
    }

    const elapsedSample = (now - this.lastSampleTime) / 1000;
    if (elapsedSample >= 0.4) {
      const bytesInSample = bytesDone - this.lastSampleBytes;
      const currentSpeed = Math.max(0, bytesInSample / elapsedSample);
      this.smoothedSpeed = this.smoothedSpeed === 0 ? currentSpeed : this.smoothedSpeed * 0.7 + currentSpeed * 0.3;
      this.lastSampleTime = now;
      this.lastSampleBytes = bytesDone;
    }

    const effectiveSpeed = this.smoothedSpeed > 0 ? this.smoothedSpeed : bytesDone / elapsedTotal;
    const speedFormatted = effectiveSpeed > 0 ? `${formatBytes(effectiveSpeed)}/s` : "—";

    const remainingBytes = Math.max(0, bytesTotal - bytesDone);
    let etaFormatted = "—";
    if (effectiveSpeed > 1024 && remainingBytes > 0) {
      const etaSeconds = Math.round(remainingBytes / effectiveSpeed);
      if (etaSeconds < 60) {
        etaFormatted = `${etaSeconds}s`;
      } else if (etaSeconds < 3600) {
        const m = Math.floor(etaSeconds / 60);
        const s = etaSeconds % 60;
        etaFormatted = `${m}m ${s}s`;
      } else {
        const h = Math.floor(etaSeconds / 3600);
        const m = Math.floor((etaSeconds % 3600) / 60);
        etaFormatted = `${h}h ${m}m`;
      }
    }

    const percent = bytesTotal > 0 ? Math.min(100, Math.round((bytesDone / bytesTotal) * 100)) : 0;

    return {
      speedFormatted,
      etaFormatted,
      percent,
    };
  }
}
